var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 155,
    viewBox: "0 0 231 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.459 137.469C156.739 140.031 164.39 141.385 172.107 141.478C172.107 141.478 173.953 144.06 172.849 149.224",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.894 147.367C190.894 147.367 193.476 138.517 189.79 139.621C186.104 140.725 177.622 143.312 177.622 143.312",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.232 153.453C144.295 153.453 149.611 147.825 150.597 146.693L150.761 146.506L169.293 151.8C171.551 152.446 173.94 152.485 176.218 151.913L185.396 149.648V151.047C185.913 151.639 186.636 152.014 187.418 152.094C187.497 152.1 187.576 152.1 187.655 152.094C188.641 151.959 193.176 149.665 195.486 148.454L196.052 144.388L217.506 135.25L217.133 138.941L224.624 136.11L225.728 126.156L228.689 124.865L229.957 118.875L229.221 116.632C227.919 111.537 224.816 101.396 222.359 99.4365L222.223 99.3232V99.1477C222.172 98.2304 220.411 89.6919 174.446 72.1223L174.298 72.06L172.413 69.4384L145.761 47.1918C144.227 46.4954 111.618 31.7625 90.9176 31.7625C88.6224 31.7354 86.3315 31.969 84.089 32.4589C76.9887 34.1575 70.1432 36.0034 63.7336 38.0191L63.1674 38.189V37.9795C62.7144 37.9795 61.8708 37.9399 60.6817 37.9399C51.689 37.9806 42.7263 38.979 33.945 40.9182L32.7447 41.2126C21.4204 43.7209 14.6258 45.2384 10.6623 48.4318C9.47379 49.2397 8.53446 50.3633 7.95011 51.6762C7.71244 52.1173 7.49885 52.571 7.31029 53.0352L6.69877 61.1943L6.28544 61.149C6.18173 61.1426 6.07772 61.1426 5.97402 61.149C5.52463 61.1508 5.08211 61.2594 4.68305 61.4661C3.55062 62.0323 2.61636 63.3686 1.98786 65.4296C1.25178 67.7907 0.889407 69.1949 0.906393 69.6026H1.08192L1.17818 69.8178C3.72048 75.3384 7.40654 82.3425 9.50154 83.8995C12.3722 86.0512 22.1904 89.2786 22.6038 89.4145L22.8586 89.4937V89.7599C23.187 93.7234 24.8573 101.163 32.3313 106.016C34.0582 107.218 36.0996 107.887 38.203 107.941V107.941C38.9775 107.941 39.7486 107.838 40.4962 107.635C45.2184 106.35 48.2533 101.498 49.0687 100.042L49.414 99.4252L51.0051 102.211L51.1863 104.374L114.602 131.473V131.728C114.659 133.109 115.497 145.385 127.625 151.358C130.291 152.723 133.237 153.452 136.232 153.487V153.453Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.499 98.825C49.499 98.825 46.0394 107.884 38.4351 108.224C38.4351 108.224 27.4449 108.088 23.2266 92.8797C23.2266 92.8797 19.3537 71.239 33.594 74.1946C47.8343 77.1503 49.499 98.825 49.499 98.825Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.084 144.241C151.084 144.241 151.084 150.883 139.006 153.301C139.006 153.301 126.38 156.896 117.343 141.591C117.343 141.591 112.088 134.865 115.225 120.76C115.225 120.76 116.08 116.061 119.557 113.292C122.784 110.727 128.282 109.894 137.07 114.492C137.07 114.492 146.469 120.301 147.262 130.023C147.262 130.023 146.016 135.119 148.96 137.35C148.955 137.328 149.6 142.401 151.084 144.241Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.063 71.9297C170.063 71.9297 198.94 82.9936 212.371 93.0835C212.371 93.0835 219.33 96.311 217.716 99.2609C217.716 99.2609 182.548 111.57 165.177 119.543L163.84 118.41L117.677 92.3928C117.677 92.3928 114.495 90.6432 115.605 90.411C116.714 90.1789 167.594 74.1436 167.594 74.1436C167.594 74.1436 170.476 73.1924 170.063 71.9297Z",
    fill: "#7A2682",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0888 41.558C53.0888 41.558 64.5207 36.949 84.0607 32.34C103.601 27.731 145.818 47.0899 145.818 47.0899L172.549 69.3988L174.395 71.9751C223.616 90.7791 222.325 99.2383 222.325 99.2383C225.462 101.452 229.335 116.57 229.335 116.57L230.071 118.778L228.78 124.865L225.824 126.179L224.72 136.133L216.974 139.083L217.342 135.397L196.143 144.428L195.577 148.482C195.577 148.482 188.941 151.987 187.65 152.174C186.359 152.361 185.255 151.041 185.255 151.041V149.75L176.195 152.015C173.916 152.582 171.529 152.541 169.27 151.896L150.778 146.614C150.778 146.614 141.447 158.255 127.563 151.404C114.478 144.983 114.478 131.513 114.478 131.513",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5977 37.8719C63.5977 37.8719 50.5068 37.1358 33.9167 40.8219C17.3266 44.508 9.94885 46.0141 7.18572 52.9899L6.26279 64.7898C6.26279 64.7898 23.7758 74.3758 24.3307 74.925",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.156 60.1695C99.5467 61.4604 101.574 64.5916 101.574 64.5916C101.574 64.5916 110.237 80.2644 111.347 85.6095C112.456 90.9546 115.588 90.3997 115.588 90.3997C115.588 90.3997 167.759 74.5457 169.231 73.2547C170.703 71.9637 168.863 70.3047 168.863 70.3047L146.99 50.8552C146.519 50.4297 145.949 50.127 145.333 49.9739C144.717 49.8208 144.072 49.8221 143.457 49.9776L104.156 60.1695Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.736 106.084L128.673 96.4978",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.588 91.3113C115.588 91.3113 162.227 116.383 165.177 119.52L176.79 114.169L159.616 107.856",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63083 61.0981C6.63083 61.0981 3.49966 59.9656 1.84065 65.339C0.181638 70.7124 0.917717 69.58 0.917717 69.58C0.917717 69.58 6.44964 81.7479 9.41094 83.9618C12.3722 86.1757 22.4792 89.4881 22.4792 89.4881",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6676 45.7989C15.6676 45.7989 11.9363 47.5599 15.1014 49.4001C18.3741 51.3195 30.6157 56.4891 30.6157 56.4891C30.6157 56.4891 8.30681 49.6945 7.2027 55.5718C7.18571 55.5718 5.15866 48.5621 15.6676 45.7989Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6937 43.4038C50.6937 43.4038 35.5758 52.435 32.8126 56.4891",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.559 113.456C179.559 113.456 207.949 101.843 217.716 99.2383C217.716 99.2383 219.194 97.0244 215.876 95.1842C212.558 93.344 195.226 81.1704 174.027 73.6114",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195.084 87.6988C191.778 85.189 188.316 82.893 184.717 80.825",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.102 101.107C211.102 101.107 206.131 96.3902 199.546 91.1244",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.149 144.428C196.149 144.428 197.995 126.683 194.258 126.269C190.521 125.856 187.463 125.703 186.795 129.729C186.795 129.729 175.471 134.429 173.772 134.429C172.073 134.429 164.373 135.81 150.127 130.697C150.127 130.697 147.918 128.342 147.228 130.001C146.537 131.66 146.809 136.229 149.436 137.469C149.158 138.838 149.23 140.255 149.645 141.589C150.059 142.923 150.803 144.131 151.808 145.102",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.795 129.729C186.795 129.729 190.113 130.969 191.081 133.183",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.325 99.2383C222.325 99.2383 219.007 99.1477 219.007 103.292C219.007 103.292 214.862 104.261 215.689 108.688C216.199 111.609 216.389 114.577 216.255 117.538C216.255 117.538 199.523 126.802 195.515 127.079",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.824 126.179C225.824 126.179 228.129 112.997 221.77 113.275C221.77 113.275 218.174 112.709 217.897 117.697",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.749 133.874L222.466 122.261C222.7 123.261 222.7 124.301 222.466 125.301C222.047 126.683 219.839 127.374 219.839 127.374L196.624 138.16",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.471 143.137L220.943 132.215C220.943 132.215 222.047 129.452 219.975 129.452C217.903 129.452 196.33 139.541 196.33 139.541",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4027 99.629C49.4027 99.629 42.7667 112.907 32.2577 106.084C21.7488 99.261 22.6717 87.461 22.6717 87.461C22.5245 83.0898 23.3625 80.0266 24.4326 77.9146C25.1963 76.4601 26.417 75.297 27.9066 74.6043C29.3963 73.9117 31.0724 73.7279 32.6767 74.0814C49.097 77.524 49.4027 99.629 49.4027 99.629L50.8749 102.211L51.0617 104.425L114.478 131.524C114.478 131.524 111.851 108.434 128.718 111.616C145.586 114.798 147.12 129.452 147.12 129.452",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.359 111.797C132.359 111.797 111.347 102.579 112.819 128.942L52.7207 102.03",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.183 125.284L106.919 116.225C106.919 116.225 106.738 109.215 106.551 108.479C106.364 107.743 105.079 104.425 105.079 104.425L110.424 91.8775C110.424 91.8775 97.8877 61.0867 94.9377 58.3236C94.9377 58.3236 70.0526 48.3695 61.2026 46.3425",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2756 46.7219C53.2756 46.7219 39.2618 53.5164 35.5757 71.6353",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4477 61.8681L75.3977 53.5731C75.3977 53.5731 63.6657 48.2223 58.6207 50.0682C54.3345 51.6366 54.057 51.495 54.057 51.495",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5559 61.4718L82.2149 55.9398L92.6276 59.943C92.6276 59.943 96.5911 64.8124 97.3385 68.6117L94.3489 67.904C94.3489 67.904 94.7565 62.3777 89.587 64.6596L85.1762 68.0002L82.9113 71.4994L81.0881 77.3258L80.2275 79.8115L78.8063 68.0002L80.5559 61.4718Z",
    fill: "#231F20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.788 114.379L113.929 117.516",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6518 108.666L67.8387 104.98",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M213.475 108.298L188.59 117.697",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M213.475 110.138L188.59 119.543",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M131.451 145.253C136.152 144.694 139.305 138.707 138.492 131.882C137.679 125.057 133.209 119.977 128.508 120.537C123.807 121.097 120.655 127.084 121.467 133.909C122.28 140.734 126.75 145.813 131.451 145.253Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5622 101.656C38.074 101.656 40.9208 97.1995 40.9208 91.702C40.9208 86.2045 38.074 81.7479 34.5622 81.7479C31.0505 81.7479 28.2036 86.2045 28.2036 91.702C28.2036 97.1995 31.0505 101.656 34.5622 101.656Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.642 116.406C132.642 116.406 144.436 117.142 142.964 138.528",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M117.156 130.414C117.156 130.414 117.524 147.746 131.878 147.746",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M38.622 79.166C38.622 79.166 47.1152 81.7479 43.7802 99.0741",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9762 86.1701C24.9762 86.1701 22.3942 100.552 34.1942 104.238",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185.368 130.788L184.128 124.186C184.005 123.531 183.745 122.91 183.366 122.363C182.987 121.816 182.496 121.354 181.927 121.009C181.357 120.664 180.721 120.443 180.061 120.36C179.4 120.277 178.729 120.334 178.092 120.528L167.753 123.676C166.745 123.989 165.661 123.958 164.673 123.586L155.885 120.188C154.747 119.75 153.483 119.767 152.357 120.238C151.232 120.708 150.331 121.595 149.844 122.714C148.711 125.296 147.698 128.325 148.496 129.316",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M129.505 139.27C131.441 139.27 133.01 136.793 133.01 133.738C133.01 130.683 131.441 128.206 129.505 128.206C127.569 128.206 126 130.683 126 133.738C126 136.793 127.569 139.27 129.505 139.27Z",
    fill: "#231F20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6528 96.4922C36.232 96.4922 37.5122 94.4717 37.5122 91.9794C37.5122 89.4871 36.232 87.4667 34.6528 87.4667C33.0736 87.4667 31.7934 89.4871 31.7934 91.9794C31.7934 94.4717 33.0736 96.4922 34.6528 96.4922Z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M128.033 5.4278L127.478 45.244L100.379 51.3309L100.934 8.74582L128.033 5.4278Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M100.934 8.74582L85.816 3.58194L85.0743 45.244L100.379 51.3309L100.934 8.74582Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.033 5.4278L108.674 1L85.816 3.58194L100.934 8.74582L128.033 5.4278Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.387 23.4957C117.349 23.4957 119.749 20.441 119.749 16.6728C119.749 12.9047 117.349 9.84994 114.387 9.84994C111.426 9.84994 109.025 12.9047 109.025 16.6728C109.025 20.441 111.426 23.4957 114.387 23.4957Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M114.387 21.463C116.467 21.463 118.153 19.3184 118.153 16.6728C118.153 14.0273 116.467 11.8826 114.387 11.8826C112.308 11.8826 110.622 14.0273 110.622 16.6728C110.622 19.3184 112.308 21.463 114.387 21.463Z",
    fill: "#231F20"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M115.129 45.3346C119.41 45.3346 122.88 40.9186 122.88 35.4712C122.88 30.0237 119.41 25.6077 115.129 25.6077C110.848 25.6077 107.378 30.0237 107.378 35.4712C107.378 40.9186 110.848 45.3346 115.129 45.3346Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M115.129 42.396C118.134 42.396 120.57 39.2956 120.57 35.4712C120.57 31.6467 118.134 28.5464 115.129 28.5464C112.124 28.5464 109.688 31.6467 109.688 35.4712C109.688 39.2956 112.124 42.396 115.129 42.396Z",
    fill: "#231F20"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9425 11.9223L98.4426 27.1308L93.0523 26.3041L95.5379 42.0676L88.4886 22.7087L92.7748 23.5354L91.9425 11.9223Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5332 88.2651C80.5332 88.2651 80.2048 45.9122 69.0674 61.1943C62.1822 70.6444 67.7708 86.3286 73.0309 96.9225C75.862 102.641 82.2036 102.449 84.8478 96.5658C91.4895 81.7762 100.407 58.7143 88.1149 65.2711C88.1149 65.2711 82.3225 68.6004 80.3521 80.825",
    fill: "#A16EFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5332 88.2651C80.5332 88.2651 80.2048 45.9122 69.0674 61.1943C62.1822 70.6444 67.7708 86.3286 73.0309 96.9225C75.862 102.641 82.2036 102.449 84.8478 96.5658C91.4895 81.7762 100.407 58.7143 88.1149 65.2711C88.1149 65.2711 82.3225 68.6004 80.3521 80.825",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7824 65.0106C44.7824 65.0106 45.5921 48.3865 59.3568 52.0386C73.1215 55.6907 67.85 67.0377 58.5471 71.4994C58.5471 71.4994 82.9736 72.9773 68.739 91.317C54.5043 109.657 41.9457 79.6076 44.7824 65.0106Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.953 78.798C101.953 78.798 101.545 63.3912 90.1929 69.0647C90.1929 69.0647 80.8673 73.9342 92.6276 91.3679C92.6276 91.3679 88.1658 81.6347 84.9214 84.8791C81.677 88.1235 85.3291 112.856 94.247 110.019C103.165 107.182 95.8663 80.4173 95.8663 80.4173C95.8663 80.4173 103.165 105.15 101.953 78.798Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5156 60.7357C54.5156 60.7357 57.7544 62.1569 58.9717 65.1975",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5833 58.5275C57.0937 60.9725 55.3299 64.0592 54.4873 67.4453",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3929 80.1172C60.3929 80.1172 63.6374 81.5328 64.8547 84.5733",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4606 77.8863C62.9727 80.3327 61.2092 83.4189 60.3647 86.8042",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2234 51.4328L59.4814 49.7341C59.4814 49.7341 65.9645 48.8225 75.0919 53.6976L73.8746 57.8027C73.8746 57.8027 70.6302 58.2613 67.1819 63.6347C63.7337 69.0081 75.9016 52.9502 55.2234 51.4328Z",
    fill: "#231F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M118.934 87.0251C118.934 87.0251 127.138 86.7023 128.039 78.1751C128.039 78.1751 129.064 86.5721 137.461 86.8948C137.461 86.8948 129.126 87.6649 128.226 95.7448C128.226 95.7448 127.269 87.4101 118.934 87.0251Z",
    fill: "white",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M166.043 88.5312C166.043 88.5312 150.229 83.6617 153.269 92.7835C156.31 101.905 177.616 98.8646 177.616 98.8646C178.911 96.1652 179.363 93.1386 178.913 90.1789C178.166 85.6775 174.853 79.9474 171.422 80.3777C168.936 80.6551 166.802 84.1317 166.043 88.5312Z",
    fill: "#FF3351",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCar);
export default __webpack_public_path__ + "static/media/leftCar.fee5da8b76d0c8970204db4614b27be7.svg";
export { ForwardRef as ReactComponent };